import {
  AdminSearchConfiguration,
  CreateSearchConfigOperationRequest,
  CreateSearchConfigRequest,
  CreateSearchConfigResponse,
  DeleteSearchOverrideRequest,
  GetSearchCollectionsRequest,
  GetSearchConfigRequest,
  GetSearchOverridesRequest,
  QueryCollectionRequest,
  SaveSearchConfigRequest,
  SearchApi,
  SearchCollection,
  SearchOverride,
  SearchResultPage,
  UpsertSearchOverride,
  UpsertSearchOverrideRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getCollections = async (): Promise<SearchCollection[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const request: GetSearchCollectionsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return (await api.getSearchCollections(request)).collections
}

const getSearchOverrides = async (hostname: string): Promise<SearchOverride[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const request: GetSearchOverridesRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    hostname,
  }

  return (await api.getSearchOverrides(request)).overrides
}

const upsertSearchOverride = async (upsertSearchOverride: UpsertSearchOverride): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const request: UpsertSearchOverrideRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    upsertSearchOverride,
  }

  return await api.upsertSearchOverride(request)
}

const deleteSearchOverride = async (overrideName: string, hostname: string): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const request: DeleteSearchOverrideRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    overrideName,
    hostname,
  }

  return await api.deleteSearchOverride(request)
}

const getAdminSearchConfig = async (hostname: string): Promise<AdminSearchConfiguration> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const request: GetSearchConfigRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    hostname,
  }

  return await api.getSearchConfig(request)
}

const saveAdminSearchConfig = async (
  hostname: string,
  searchConfig: AdminSearchConfiguration,
): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const request: SaveSearchConfigRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    hostname,
    adminSearchConfiguration: searchConfig,
  }

  return await api.saveSearchConfig(request)
}

const searchDocuments = async (
  hostname: string,
  fieldName: string,
  searchTerm: string,
  page: number,
  pageSize: number,
): Promise<SearchResultPage> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const request: QueryCollectionRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    fieldName,
    searchTerm,
    hostname,
    page,
    pageSize,
  }

  return await api.queryCollection(request)
}

const createSearchConfig = async (
  createSearchConfigRequest: CreateSearchConfigRequest,
): Promise<CreateSearchConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SearchApi)

  const operationRequest: CreateSearchConfigOperationRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    createSearchConfigRequest,
  }

  return await api.createSearchConfig(operationRequest)
}

export const SearchServiceAPI = {
  getSearchOverrides,
  upsertSearchOverride,
  getCollections,
  searchDocuments,
  getAdminSearchConfig,
  saveAdminSearchConfig,
  deleteSearchOverride,
  createSearchConfig,
}
